<template>
  <base-section id="pro-features">
    <!-- <v-img
      :src="require('@/assets/logo.svg')"
      class="mx-auto mb-8"
      max-width="128"
    /> -->

    <base-section-heading title="A little about us">
      <p style="font-size: 16px">
        With a mission of ‘Transforming Transportation via Innovation’ , Truk
        was spun off from Zoyride which was founded in 2015 by ex. premier
        Indian Institute graduates, with an idea of making traveling a joyride
        experience. The existing Transport Automation solution/Transport ERP
        developed by Zoyride was updated to address the needs for the
        shipping/logistic industry.
        <br />
        <br />
        We are deeply focused on understanding the grass root problems in
        transportation industry and provide them the perfect solution to all the
        actors in this ecosystem.
        <br />
        <br />
        We provide ease to start Cloud based solution, where you can subscribe
        to our service in pay as you use model.
        <br />
        <br />
        It's an very well integrated Client-Vendor platform, where both the
        parties can use independently and consume/supply services. If you a
        corporate and need to manage your employee or general transport need,
        Truk can provide awesome tool to mange it effortlessly. Truk helps an
        shipper with safe & secure transport at optimised cost and higher
        reliability.
        <br />
        <br />
        <br />
        If you are a car rental company you can use our solution as an ERP
        solution to manage your end to end business. You can provide customized
        services to your multiple clients as per their requirement. You can take
        services from multiple suppliers.
      </p>
    </base-section-heading>
  </base-section>
</template>

<script>
export default {
  name: "SectionFeaturesAlt",

  data: () => ({
    features: [
      "Zero Installation",
      "Easy Customization",
      "User Friendly Design",
      "24/7 Support Desk",
      "SEO Optimized",
    ],
  }),
};
</script>
